export default __webpack_public_path__ + "static/media/store-background.f78b38fe.jpg";